/** Catálogo oficial Uñas (Shopify CDN + copia local). */
export const CATALOGO_UNAS_PDF =
  'https://cdn.shopify.com/s/files/1/0645/0541/3768/files/Oh_Belleza_-_Catalogo_Unas.pdf?v=1727064267';

/** PDF local (tienda o API). */
export const CATALOGO_UNAS_LOCAL = '/catalogos/catalogo-unas.pdf';

/** Orden de fuentes para abrir el PDF (proxy → API → CDN). */
export function catalogoUnasPdfCandidates() {
  const api = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
  const list = [CATALOGO_UNAS_LOCAL];
  if (api) list.push(`${api}/catalogos/catalogo-unas.pdf`);
  else if (process.env.NODE_ENV !== 'production') {
    list.push('http://localhost:8081/catalogos/catalogo-unas.pdf');
  }
  list.push(CATALOGO_UNAS_PDF);
  return [...new Set(list)];
}

export const CATALOGO_UNAS_TITLE = 'Catálogo Uñas';
export const CATALOGO_UNAS_SUBTITLE =
  'Todo el catálogo oficial de manicure y pedicure — organizado por línea de producto.';

/** Sección catálogo agosto — alias legacy: Manicure y Pedicure */
export const MANICURE_CATEGORY = 'UÑAS';

export function isManicureCategory(nombre) {
  const n = String(nombre || '').trim();
  if (!n) return false;
  const norm = n
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
  return norm === 'UNAS' || n === 'Manicure y Pedicure' || n === MANICURE_CATEGORY;
}

/** Sub-líneas dentro de Uñas */
export const UNAS_LINEAS = [
  {
    id: 'todas',
    nombre: 'Todas',
    blurb: 'Catálogo completo',
  },
  {
    id: 'esmaltes',
    nombre: 'Esmaltes',
    blurb: 'Semipermanente, tradicional y colores',
    match: /esmalte|semi\b|gelish|loto|barniz|pintura u[nñ]a/i,
  },
  {
    id: 'acrilicos',
    nombre: 'Acrílicos',
    blurb: 'Polvos, monómero y sistemas acrílicos',
    match: /acr[ií]lico|polvo acr|mon[oó]mer|cover beige|cover pink|clear powder/i,
  },
  {
    id: 'geles',
    nombre: 'Geles',
    blurb: 'Builder, rubber, painting y spider gel',
    match:
      /painting\s*gel|spider\s*gel|builder\s*gel|rubber\s*(base|gel)|gel\s*metalizado|poly\s*gel|polygel|gel\s*pegante|hard\s*gel|soft\s*gel|uv\s*gel|gel\s*uv|gel\s*constructor|constructor\s*gel|building\s*gel|\bgeles?\b(?!\s*ish)/i,
  },
  {
    id: 'tips',
    nombre: 'Tips y moldes',
    blurb: 'Tips, dual forms y moldes',
    match: /\btips?\b|tip\s|dual form|molde u[nñ]a|formas|nail tip/i,
  },
  {
    id: 'decoracion',
    nombre: 'Decoración',
    blurb: 'Glitter, pigmentos y adornos',
    match: /pigmento|escarcha|glitter|caviar|drima|mirella|decorat|foil|strass|perla|joya u[nñ]a/i,
  },
  {
    id: 'herramientas',
    nombre: 'Herramientas',
    blurb: 'Limas, cortes y sets de manicure',
    match: /lima\b|bloque|set manic|manicura|alicate|tijera manic|pusher|pincel nail|torno|fresa nail/i,
  },
  {
    id: 'cuidado',
    nombre: 'Cuidado y prep',
    blurb: 'Cutícula, removedores y prep',
    match: /cut[ií]cula|removedor|acetona|prep|primer nail|base coat|top coat|quitadur|salvita|aceite cut/i,
  },
];

export function matchUnasLinea(product, lineaId) {
  if (!lineaId || lineaId === 'todas') return true;
  const linea = UNAS_LINEAS.find((l) => l.id === lineaId);
  if (!linea?.match) return true;
  const text = [product?.codigo, product?.nombre, product?.referencia, product?.descripcion]
    .filter(Boolean)
    .join(' ');
  if (lineaId === 'geles' && /antibacterial|depilador|gelatinoso|labial\s*gel/i.test(text)) return false;
  return linea.match.test(text);
}

export function countByUnasLinea(products = []) {
  const counts = { todas: products.length };
  for (const linea of UNAS_LINEAS) {
    if (linea.id === 'todas') continue;
    counts[linea.id] = products.filter((p) => matchUnasLinea(p, linea.id)).length;
  }
  return counts;
}
